// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".accidentChart {\n  padding: 20px !important;\n  border: 1px solid #dee2e6;\n  border-top: 3px solid #dee2e6;\n}", ""]);
// Exports
module.exports = exports;
